import axios from 'axios';
import * as Config from '../../config';

const state = {};

const actions = {
    invoiceList_getEmitido({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'invoice-list/get-emitido?idUser=' + form.idUser + '&month=' + encodeURIComponent(form.month || ''))
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    invoiceList_getEmitidoList({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'invoice-list/get-emitido-list?idUser=' + form.idUser)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    invoiceList_getRecibido({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'invoice-list/get-recibido?idUser=' + form.idUser + '&month=' + encodeURIComponent(form.month || ''))
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    invoiceList_getRecibidoList({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'invoice-list/get-recibido-list?idUser=' + form.idUser)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
}

const mutations = {

};

export default {
    state,
    actions,
    mutations
};